import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const airtable = defineConnector({
  identifier: "airtable",
  name: "Airtable",
  tagLine: "Collaborative database",
  keywords: "bases tables records fields spreadsheet database no code",
  logo,
  protocol: "http",
  tags: ["featured", "productivity", "data"],
  defaultUrlPattern: () => "https://api\\.airtable\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Airtable account](https://airtable.com/account) and generate a personal access token from the Developer Hub.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Airtable API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.airtable.com/v0/meta/bases",
      expectedStatus: [200, 403],
    }),
  },
});
